const LOAD_ERROR_TYPES = {
    AUTH_TOKEN_WRONG: 0,
    AUTH_TOKEN_NOT_FOUND: 1,
    PAGE_LOAD_ERROR: 2,
    NETWORK_ERROR: 3,
    SERVER_ERROR: 4,
    WRONG_SIGN_UP_TOKEN: 5
}
export default LOAD_ERROR_TYPES;